export const fileNameMap: { [k: string]: string } = {
    "dbn_series_discrepancy_": "Series Level Discrepancy",
    "dbn_investor_discrepancy_": "Investor Level Discrepancy",
    "dbn_pf_": "Performance Fee",
    "dlw_discrepancy_": "Discrepancy",
    "dlw_pf_": "Performance Fee",
    "sac_pf_": "Performance Fee",
    "dbn_nav_": "Monthly NAV Report"
}
